// extracted by mini-css-extract-plugin
export default {"password":"password_AimlD","title":"title_luicB","footer":"footer_EVzfb"};